import { findCountryCodeByName, getCountryName } from "@reactive-resume/utils";
import { type Country, getCountries, getCountryCallingCode } from "react-phone-number-input";

export type CvCountry = {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
};

const toFlag = (code: string) =>
  String.fromCodePoint(...[...code].map((letter) => 0x1f1e6 + letter.charCodeAt(0) - 65));

// Tous les pays et indicatifs connus de libphonenumber, noms en français.
export const CV_COUNTRIES: CvCountry[] = getCountries()
  .map((code: Country) => ({
    code,
    name: getCountryName(code),
    dialCode: `+${getCountryCallingCode(code)}`,
    flag: toFlag(code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name, "fr"));

const CV_COUNTRY_CODES = CV_COUNTRIES.map((country) => country.code);

export const findCountryByCode = (code?: string | null) =>
  CV_COUNTRIES.find((country) => country.code === code);

export const findCountryByName = (name: string) =>
  findCountryByCode(findCountryCodeByName(name, CV_COUNTRY_CODES));
